import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import CreatePlaylistModalTrigger from './CreatePlaylistModalTrigger';
import { jsx as _jsx } from "react/jsx-runtime";
const CreatePlaylistLink = ({
  item,
  children = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.createPlaylist"
  }),
  render
}) => {
  return /*#__PURE__*/_jsx(CreatePlaylistModalTrigger, {
    item: item
    // renderTrigger prop allows us to render any custom trigger component we want
    // We pass the output of the render function to the renderTrigger prop
    // and fallback to the default trigger if no custom render function is provided
    ,
    renderTrigger: ({
      openModal
    }) => render ? render(children, openModal) : /*#__PURE__*/_jsx(Button, {
      onClick: openModal,
      use: "link",
      children: children
    })
  });
};
export default CreatePlaylistLink;